import { render, staticRenderFns } from "./passport.vue?vue&type=template&id=d9aa79ec&"
import script from "./passport.vue?vue&type=script&lang=js&"
export * from "./passport.vue?vue&type=script&lang=js&"
import style0 from "./passport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports